"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sdAssertUnreachable = sdAssertUnreachable;
const ShapeDiverErrors_1 = require("./ShapeDiverErrors");
function sdAssertUnreachable(_) {
    throw new ShapeDiverErrors_1.ShapeDiverError("Reached unreachable block");
}
//# sourceMappingURL=utils.js.map